
const green = '#238F23'
const red = '#d60000'
const yellow = '#FFA500'
const blue = '#00008B'
const gray = '#333333'

const isForTomorrow = (completedAt, targetDate) => {
  completedAt = completedAt || new Date()
  const tomorrowDueDate = new Date(targetDate).setHours(0, 0, 0, 0)
  const tomorrowDate = new Date(new Date(completedAt).getFullYear(), new Date(completedAt).getMonth(), new Date(completedAt).getDate(completedAt) + 1).setHours(0, 0, 0, 0)
  if (tomorrowDate === tomorrowDueDate) {
    return true
  }
  return false
}

const isForToday = (completedAt, targetDate) => {
  completedAt = completedAt || new Date()
  return new Date(completedAt).setHours(0, 0, 0, 0) === new Date(targetDate).setHours(0, 0, 0, 0)
}

const isOverDue = (completedAt, targetDate) => {
  completedAt = completedAt || new Date()
  return new Date(targetDate).setHours(0, 0, 0, 0) < new Date(completedAt).setHours(0, 0, 0, 0)
}

const isPending = (completedAt, targetDate) => {
  completedAt = completedAt || new Date()
  return new Date(targetDate).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)
}

const getDueDateColor = (completedAt, targetDate, completed) => {
  if (isOverDue(completedAt, targetDate)) {
    return red
  }

  if (isForTomorrow(completedAt, targetDate)) {
    return blue
  }

  if (isForToday(completedAt, targetDate)) {
    return yellow
  }

  if (completed === true) {
    return green
  }

  if (isPending(completedAt, targetDate)) {
    return gray
  }

  return gray
}

export default getDueDateColor
